import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  LinearProgress,
  CircularProgress,
  IconButton,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  Select,
  FormControl,
  MenuItem, Autocomplete,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const FormEditMembershipService = ({ membershipData, setMembershipData,groups,isGroupsLoading }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [selectedGroups, setSelectedGroups] = useState([]);
  const itemsPerPage = 25;
  const [groupsPage, setGroupsPage] = useState(1);
  const [groupSearchQuery, setGroupSearchQuery] = useState("");

  useEffect(() => {
    if (membershipData?.groups && groups.length > 0) {
      const initialSelected = groups.filter(group =>
          membershipData.groups.includes(group.id)
      );
      setSelectedGroups(initialSelected);
    }
  }, [membershipData, groups]);

  // Pagination and search logic
  const paginatedGroups = groups.slice(0, groupsPage * itemsPerPage);
  const filteredGroups = groups.filter((group) =>
      group.name.toLowerCase().includes(groupSearchQuery.toLowerCase())
  );
  const displayedGroups = groupSearchQuery ? filteredGroups : paginatedGroups;


  const handleGroupChange = (event, newValue) => {
    setSelectedGroups(newValue);
    const groupIds = newValue.map(group => group.id);
    setMembershipData(prev => ({ ...prev, groups: groupIds }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMembershipData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formData = new FormData();
    formData.append('title', membershipData.title);
    formData.append('description', membershipData.description);
    formData.append('count', membershipData.count);
    formData.append('is_active', membershipData.is_active ? 1 : 0);
    formData.append('all', membershipData.all ? 1 : 0);

    membershipData.groups.forEach(groupId => {
      formData.append('groups[]', groupId);
    });
    try {
      const { response } = await Helper.Put({
        url: `${api_Routes.MembershipService.Edit}${id}`,
        data: formData,
        isFormData: true
      });

      if (response) {
        dispatch(setSuccess(true));
        navigate("/Membership-Services");
      }
    } catch (error) {
      console.error("Update error:", error);
      setErrorMessage(error.message);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          <TextField
              fullWidth
              margin="normal"
              label="Title"
              name="title"
              required
              value={membershipData.title}
              onChange={handleInputChange}
              variant="outlined"
          />

          <TextField
              fullWidth
              margin="normal"
              label="Count"
              name="count"
              required
              type="number"
              value={membershipData.count}
              onChange={handleInputChange}
              variant="outlined"
          />


          <TextField
              fullWidth
              margin="normal"
              label="Description"
              name="description"
              multiline
              rows={2}
              value={membershipData.description}
              onChange={handleInputChange}
              variant="outlined"
          />

          <div className="w-full">
            <Autocomplete
                multiple
                disablePortal
                loading={isGroupsLoading}
                options={displayedGroups}
                getOptionLabel={(option) => option.name || ""}
                value={selectedGroups}
                onChange={handleGroupChange}
                onInputChange={(event, value) => setGroupSearchQuery(value)}
                renderInput={(params) => (
                    <TextField {...params} label="Groups" variant="outlined" />
                )}
                ListboxProps={{
                  onScroll: (event) => {
                    const listboxNode = event.currentTarget;
                    if (listboxNode.scrollTop + listboxNode.clientHeight >=
                        listboxNode.scrollHeight - 3) {
                      setGroupsPage(prev => prev + 1);
                    }
                  },
                }}
            />
          </div>

          <div className="w-full flex items-center justify-start gap-x-3">
            <FormLabel sx={{ fontWeight: "bold" }} component="legend">
              Active:
            </FormLabel>
            <RadioGroup
                name="is_active"
                value={membershipData.is_active.toString()}
                onChange={(e) => {
                  const value = e.target.value === 'true';
                  setMembershipData(prev => ({ ...prev, is_active: value }));
                }}
                row
            >
              <FormControlLabel value="true" control={<Radio />} label="Yes" />
              <FormControlLabel value="false" control={<Radio />} label="No" />
            </RadioGroup>
          </div>

          <div className="w-full flex items-center justify-start gap-x-3">
            <FormLabel sx={{ fontWeight: "bold" }} component="legend">
              All:
            </FormLabel>
            <RadioGroup
                name="all"
                value={membershipData.all.toString()}
                onChange={(e) => {
                  const value = e.target.value === 'true';
                  setMembershipData(prev => ({ ...prev, all: value }));
                }}
                row
            >
              <FormControlLabel value="true" control={<Radio />} label="Yes" />
              <FormControlLabel value="false" control={<Radio />} label="No" />
            </RadioGroup>
          </div>
        </div>

        {errorMessage && (
            <div className="w-full text-start text-red-600">*{errorMessage}</div>
        )}

        <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={isLoadingSubmit}
            color="primary"
            sx={{
              display: isLoadingSubmit ? "flex" : "block",
              marginTop: 2,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoadingSubmit ? (
              <CircularProgress size={24} color="primary" />
          ) : (
              "Update Membership Service"
          )}
        </Button>
      </form>
  );
};
